import Vue from 'vue'
import moment from 'moment'
import { asign_data } from './datadb/index.js';
import { deepCopy } from './functions/functions.js';
import router from '@/services/router.js';
import idb from '@/api/datadb';

const data_asign_data = () => { return asign_data() }

function fecha(date = null) {
    function beetween(d) {
        var ano = moment(d).format('YYYY')
        var mes = moment(d).format('MM')
        var dia = moment(d).format('DD')
        var hora = moment(d).format('H')
        var minutos = moment(d).format('mm')
        var segundos = moment(d).format('ss')

        var manana = moment(d).add(1, 'days');
        var ano2 = moment(manana).format('YYYY')
        var mes2 = moment(manana).format('MM')
        var dia2 = moment(manana).format('DD')

        return { inicial: ano + '-' + mes + '-' + dia + ' ' + hora + ':' + minutos + ':' + segundos, final: ano2 + '-' + mes2 + '-' + dia2 + ' 23:59:00', anoHoy: ano };
    }

    function dateFormat(d) {
        var ano = moment(d).format('YYYY')
        var mes = moment(d).format('MM')
        var dia = moment(d).format('DD')
        var hora = moment(d).format('H')
        var minutos = moment(d).format('mm')
        var segundos = moment(d).format('ss')
        var milisegundos = moment(d).format('ms')

        return { hoy: ano + '-' + mes + '-' + dia + 'T' + hora + ':' + minutos + ':' + segundos + ':' + milisegundos + 'Z', minHoy: ano + '-' + mes + '-' + dia, betHoy: ano + '' + mes + '' + dia };
    }

    function dateProximo(d) {
        var ano = parseInt(moment(d).format('YYYY'))
        var mes = parseInt(moment(d).format('MM')) + 1
        if (mes > 12) {
            mes = 1;
            ano = ano + 1
        }
        return { mes: mes, ano: ano }
    }

    function dateInicioLabores(d) {
        var ano = moment(d).format('YYYY')
        var mes = moment(d).format('MM')
        var dia = moment(d).format('DD')

        return { servicios: ano + '-' + mes + '-01', nuevo: ano + '-' + mes + '-' + dia }
    }
    if (date === null) {
        date = new Date()
    }
    var dateNow = moment(date).format();
    return { beetween: beetween(dateNow), fecha: dateFormat(dateNow), proximoPago: dateProximo(dateNow), inicioLabores: dateInicioLabores(dateNow) }
}

// Constants 
const dataForm = () => {
    return deepCopy(data_asign_data().dataForm)
}
const dataPost = () => {
    var dataPost = deepCopy(data_asign_data().dataPost)
    return dataPost

}
const dataGet = () => {
    var dataGet = deepCopy(data_asign_data().dataGet)
    return dataGet
}


const dataIndex = () => {
    var dataIndex = deepCopy(data_asign_data().dataIndex)
    return dataIndex
}
const tableSave = () => {

    return {}
}
const dataMultiple = () => {
    let data = deepCopy(data_asign_data().dataMultiple)
    return data
}
const predeterminados = () => {
    var predeterminado = deepCopy(data_asign_data().predeterminados)
    return predeterminado
}

function arrayFechaAno() {
    var ano = moment(new Date()).format('YYYY');
    var arrayAno = []
    var final = parseInt(ano) + 1
    for (let i = final; i >= 2017; i--) {
        arrayAno.push({ id: i, name: i }, )
    }

    return arrayAno
}

// RESET CONST
function reset() {
    var returnReset = {
        produccion: false,
        dataMultiple: dataMultiple(),
        dataForm: dataForm(),
        dataPost: dataPost(),
        dataGet: dataGet(),
        dataIndex: dataIndex(),
        tableSave: tableSave(),
        predeterminados: predeterminados(),
        namePath: 'aflprueba',
        minform: false,
        renderForce: 0,
        awaitDataGet: false,
        swSearchs: {},
        searchSw: { value: '' },
        conteoData: { afiliaciones: 0, aportes: 0, retiros: 0, pendientes: 0 }
    }
    return returnReset
}



// State
export const state = {
    produccion: reset()['produccion'],
    searchSw: reset()['searchSw'],
    swSearchs: reset()['swSearchs'],
    tableSave: reset()['tableSave'],
    dataForm: reset()['dataForm'],
    dataPost: reset()['dataPost'],
    dataGet: reset()['dataGet'],
    dataIndex: reset()['dataIndex'],
    dataMultiple: reset()['dataMultiple'],
    predeterminados: reset()['predeterminados'],
    namePath: reset()['namePath'],
    renderForce: reset()['renderForce'],
    minform: reset()['minform'],
    awaitDataGet: reset()['awaitDataGet'],
    conection: { inicial: '', final: '' },
    mostrarResultado: false,
    listsDatadb: [],
    conteoData: reset()['conteoData'],
    lists: {
        datos_egresos: [],
        datos_ingresos: [],
        datos_aportes: [],
        datos_contacto: [],
        datos_afiliado: [],
        datos_asesor: [],
        datos_contacto: [],
        datos_razon: [],
        list_afp: [],
        list_arl: [],
        list_ccf: [],
        list_cuentas: [],
        list_documento: [],
        list_eps: [],
        list_estado: [],
        list_forma: [],
        list_otros: [],
        list_riesgo: [],
        list_servicios: [],
        list_subtipo: [],
        list_tipo: [],
        list_users: [],
        list_mes: [
            { id: 1, name: 'Enero' },
            { id: 2, name: 'Febrero' },
            { id: 3, name: 'Marzo' },
            { id: 4, name: 'Abril' },
            { id: 5, name: 'Mayo' },
            { id: 6, name: 'Junio' },
            { id: 7, name: 'Julio' },
            { id: 8, name: 'Agosto' },
            { id: 9, name: 'Septiembre' },
            { id: 10, name: 'Octubre' },
            { id: 11, name: 'Noviembre' },
            { id: 12, name: 'Diciembre' },
        ],
        list_ano: arrayFechaAno(),
        list_aportante: [
            { id: 1, name: 'B - Aportante con menos de 200 cotizantes' },
            { id: 2, name: 'A - Aportante con 200 o más cotizantes' },
            { id: 5, name: 'D - Beneficiario Ley 1429 de 2010' },
        ],
        list_novedad: [
            { id: 1, name: 'Ingreso' },
            { id: 2, name: 'Cotización' },
            { id: 3, name: 'Retiro' },
            { id: 4, name: 'Retiro solo AFP' },
        ],
        list_incapacidad: [
            { id: 1, name: 'AT' },
            { id: 2, name: 'EG' },
            { id: 3, name: 'LM' },
            { id: 4, name: 'LP' },
            { id: 5, name: 'SOAT' },
        ],
        list_proceso: [
            { id: 1, name: 'Pendiente' },
            { id: 2, name: 'Recibida' },
            { id: 3, name: 'Enviada' },
            { id: 4, name: 'Transcrita' },
            { id: 5, name: 'Devuelta' },
            { id: 6, name: 'Negada' },
            { id: 7, name: 'Tutela' },
            { id: 8, name: 'Consignación' },
            { id: 9, name: 'Pagada' },
        ],
    },
};
// Getters
export const getters = {
    gettersDatalist: (state, getters) => (list, id) => {
        try {
            if (list !== null && list !== '') {
                if (state.lists[list].filter(list => {
                        return (list.id.toString() === id.toString() && id != '') || (list.name.toString() === id.toString() && id != '')
                    })) {
                    return state.lists[list].filter(list => { return list.id.toString() === id.toString() || list.name.toString() === id.toString() })
                }

            }
            return ''
        } catch (e) {
            console.log('error in gettersDatalist list: ' + list + ' id: ' + id)
            return [{ name: null }]
        }

    },
    includeDatalist: (state, getters) => (list, id, compare) => {
        if (id !== '' && id !== null) {
            return state.lists[list].filter(data => data[compare].toString().toLowerCase().includes(id.toString().toLowerCase()))
        }
        return []
    },

};
// Actions
export const actions = {
    // localstorate
    async deleteDatabase() {
        return await idb.deleteDatabase()
    },
    async buscarIdb({ commit, state }, data) {
        return await idb.buscarIdb(data)
    },
    async searchGetIdb({ commit, state }, data) {
        await idb.searchGetIdb(data)
    },
    async getIdb({ commit, state }) {
        let listsKeys = Object.keys(state.lists)
        for (let i = 0; i < listsKeys.length; i++) {
            let listsDatadb = await idb.getIdb(listsKeys[i]);
            if (listsDatadb !== undefined) {
                listsDatadb.forEach(c => {
                    if (state.lists[listsKeys[i]].find(list => list.id === c.id) === undefined) {
                        state.lists[listsKeys[i]].push(c);
                    }
                });
            }
        }
    },
    async saveIdb({ commit, state }, data) {
        let listsKeys = Object.keys(data)
        for (let i = 0; i < listsKeys.length; i++) {
            await idb.saveIdb({ data: data[listsKeys[i]], list: listsKeys[i] })
        }
    },
    async deleteIdb({ commit, state }, data) {
        await idb.deleteIdb(data)
    },
    // ACTIONS FROMTO
    formToPost({ commit }, data) {
        return new Promise((resolve) => {
            commit('formToPost', { data: data, callback: resolve })
        })
    },
    formToGet({ commit }, data) {
        return new Promise((resolve) => {
            commit('formToGet', { data: data, callback: resolve })
        })
    },
    postToForm({ commit }, data) {
        return new Promise((resolve) => {
            commit('postToForm', { data: data, callback: resolve })
        })
    },
    getToForm({ commit }, data) {
        return new Promise((resolve) => {
            commit('getToForm', { data: data, callback: resolve })
        })
    },
    // ACTIONS DATAMULTIPLE
    updateDataMultiple({ commit }, data) {
        return new Promise((resolve) => {
            commit('updateDataMultiple', { data: data, callback: resolve })
        })
    },
    //ACTION SAVE BACKEND
    saveAll({ commit, state }, config) {
        return new Promise((resolve, reject) => {
            axios
                .post(config.route, { data: config.data, delete: config.tablaDelete, name_path: state.namePath, auditar: config.tablaAuditar, conection: state.conection, nota_delete: config.notaDelete })
                .then(async response => {
                    if (response.data.local.lists instanceof Array === false) {
                        let listsKeys = Object.keys(response.data.local.lists)
                        for (let i = 0; i < listsKeys.length; i++) {
                            for (let j = 0; j < response.data.local.lists[listsKeys[i]].length; j++) {
                                let indexList = state.lists[listsKeys[i]].findIndex(list => list.id === response.data.local.lists[listsKeys[i]][j].id)
                                if (indexList === -1) {
                                    state.lists[listsKeys[i]].push(response.data.local.lists[listsKeys[i]][j])
                                } else {
                                    state.lists[listsKeys[i]][indexList] = response.data.local.lists[listsKeys[i]][j]
                                }

                            }
                            /* await idb.saveIdb({data: response.data.local.lists[listsKeys[i]], list: listsKeys[i]})
                             let listsDatadb = await idb.getIdb(listsKeys[i]) 
                             listsDatadb.forEach(c => {
                                     if( state.lists[listsKeys[i]].find( list => list.id === c.id ) === undefined )
                                     {
                                             state.lists[listsKeys[i]].push(c)
                                     }                                
                             }); */
                        }
                    }
                    if (response.data.local.multiples instanceof Array === false) {
                        let data = asign_data().dataMultiple
                        let namePathDataMultiple = Object.keys(data)

                        for (let i = 0; i < namePathDataMultiple.length; i++) {
                            let listsKeys = Object.keys(response.data.data)
                            for (let j = 0; j < listsKeys.length; j++) {
                                if (response.data.data[listsKeys[j]].length > 0) {
                                    await idb.saveIdb({ data: response.data.data[listsKeys[j]], list: listsKeys[j] })
                                    data[namePathDataMultiple[i]][listsKeys[j]] = response.data.data[listsKeys[j]]

                                } else {
                                    data[namePathDataMultiple[i]][listsKeys[j]] = await idb.buscarIdb({ tabla: listsKeys[j], campo: 'id_list', value: 1 })

                                }

                                state.predeterminados[namePathDataMultiple[i]][listsKeys[j]] = deepCopy(data[namePathDataMultiple[i]][listsKeys[j]])
                            }
                        }
                        state.dataMultiple = data
                    }
                    if (response.data.local.config instanceof Array === false) {
                        let listsKeys = Object.keys(response.data.local.config)
                        for (let i = 0; i < listsKeys.length; i++) {
                            if (listsKeys[i] != 'conteo' && listsKeys[i] != 'users') {
                                await idb.saveIdb({ data: response.data.local.config[listsKeys[i]], list: listsKeys[i] })
                                state.predeterminados.configuracion[listsKeys[i]] = deepCopy(response.data.local.config[listsKeys[i]])
                            } else if (listsKeys[i] == 'conteo') {
                                state.conteoData = response.data.local.config.conteo
                            } else if (listsKeys[i] == 'users' && response.data.local.config.users !== null) {
                                window.localStorage.setItem('user', JSON.stringify(response.data.local.config.users));
                                if (state.conection.inicial != '2020-01-01') {
                                    location.reload()
                                }
                            }

                        }
                    }


                    resolve(response)
                }, error => {
                    let statusError = {...error }
                    if (statusError.response.status === 401) {
                        window.localStorage.clear();
                        commit('resetState');
                        delete axios.defaults.headers.common["Authorization"];
                        router.push('/auth/logout');
                    }
                    reject(error)
                })
        })
    },
    saveData({ commit, state }, config) {
        return new Promise((resolve, reject) => {
            axios
                .post(config.route, { data: config.data })
                .then(async response => {
                    resolve(response)
                }, error => {
                    let statusError = {...error }
                    if (statusError.response.status === 401) {
                        window.localStorage.clear();
                        commit('resetState');
                        delete axios.defaults.headers.common["Authorization"];
                        router.push('/auth/logout');
                    }
                    reject(error)
                })
        })
    },
    getDataGet({ commit, state }, config) {
        state.awaitDataGet = true
        if (state.produccion === false) {
            return new Promise((resolve, reject) => {
                axios
                    .get(config.route, { params: { data: config.data, conection: state.conection } })
                    .then(async response => {
                        if (response.data.local.lists instanceof Array === false) {
                            let listsKeys = Object.keys(response.data.local.lists)
                            for (let i = 0; i < listsKeys.length; i++) {
                                for (let j = 0; j < response.data.local.lists[listsKeys[i]].length; j++) {
                                    let indexList = state.lists[listsKeys[i]].findIndex(list => list.id === response.data.local.lists[listsKeys[i]][j].id)
                                    if (indexList === -1) {
                                        state.lists[listsKeys[i]].push(response.data.local.lists[listsKeys[i]][j])
                                    } else {
                                        state.lists[listsKeys[i]][indexList] = response.data.local.lists[listsKeys[i]][j]
                                    }

                                }
                                /*await idb.saveIdb({data: response.data.local.lists[listsKeys[i]], list: listsKeys[i]})
                                let listsDatadb = await idb.getIdb(listsKeys[i]) 
                                listsDatadb.forEach(c => {
                                        if( state.lists[listsKeys[i]].find( list => list.id === c.id ) === undefined )
                                        {
                                                state.lists[listsKeys[i]].push(c)
                                        }                                
                                });   */
                            }
                        } else {
                            if (response.data.local.multiples instanceof Array === false) {
                                let data = asign_data().dataMultiple
                                let namePathDataMultiple = Object.keys(data)

                                for (let i = 0; i < namePathDataMultiple.length; i++) {
                                    let listsKeys = Object.keys(response.data.data)
                                    for (let j = 0; j < listsKeys.length; j++) {
                                        if (response.data.data[listsKeys[j]].length > 0) {
                                            await idb.saveIdb({ data: response.data.data[listsKeys[j]], list: listsKeys[j] })
                                            data[namePathDataMultiple[i]][listsKeys[j]] = response.data.data[listsKeys[j]]

                                        } else {
                                            data[namePathDataMultiple[i]][listsKeys[j]] = await idb.buscarIdb({ tabla: listsKeys[j], campo: 'id_datos_afiliado', value: 1 })

                                        }

                                        state.predeterminados[namePathDataMultiple[i]][listsKeys[j]] = deepCopy(data[namePathDataMultiple[i]][listsKeys[j]])
                                    }
                                }
                                state.dataMultiple = data
                            }
                            if (response.data.local.config instanceof Array === false) {
                                let listsKeys = Object.keys(response.data.local.config)
                                for (let i = 0; i < listsKeys.length; i++) {
                                    if (listsKeys[i] != 'conteo' && listsKeys[i] != 'users') {
                                        await idb.saveIdb({ data: response.data.local.config[listsKeys[i]], list: listsKeys[i] })
                                        state.predeterminados.configuracion[listsKeys[i]] = deepCopy(response.data.local.config[listsKeys[i]])
                                    } else if (listsKeys[i] == 'conteo') {
                                        state.conteoData = response.data.local.config.conteo
                                    } else if (listsKeys[i] == 'users' && response.data.local.config.users !== null) {
                                        window.localStorage.setItem('user', JSON.stringify(response.data.local.config.users));
                                        if (state.conection.inicial != '2020-01-01') {
                                            location.reload()
                                        }
                                    }
                                }
                            }
                        }
                        commit('updateDataGet', { data: response.data.data, callback: resolve })
                        await idb.saveIdb({ data: { id: 1, inicial: fecha().beetween.inicial, final: fecha().beetween.final }, list: 'ultima_conexion' })
                        commit('updateCrud', { data: { state: 'conection', data: { inicial: fecha().beetween.inicial, final: fecha().beetween.final } }, callback: resolve })
                        state.awaitDataGet = false
                        resolve(response)
                    }, error => {
                        let statusError = {...error }
                        if (statusError.response.status === 401) {
                            window.localStorage.clear();
                            delete axios.defaults.headers.common["Authorization"];
                            router.push('/auth/logout');
                        }
                        state.awaitDataGet = false
                        reject(error)
                    })
            })
        }
    },
    async getDataList({ commit, state }, config) {
        if (state.produccion === false) {
            return new Promise((resolve, reject) => {
                axios
                    .get(config.route, { params: { data: config.data } })
                    .then(async response => {
                        if (response.data.lists) {
                            let listsKeys = Object.keys(response.data.lists)
                            for (let i = 0; i < listsKeys.length; i++) {
                                if (response.data.lists[listsKeys[i]].length > 0) {
                                    state.lists[listsKeys[i]] = response.data.lists[listsKeys[i]]
                                        // await idb.saveIdb({data: response.data.lists[listsKeys[i]], list: listsKeys[i]})

                                }
                                /*let listsDatadb = await idb.getIdb(listsKeys[i]) 
                                listsDatadb.forEach(c => {
                                        if( state.lists[listsKeys[i]].find( list => list.id === c.id ) === undefined )
                                        {
                                                state.lists[listsKeys[i]].push(c)
                                        }                                
                                });  */
                            }
                        }

                        resolve(true)
                    }, error => {
                        let statusError = {...error }
                        if (statusError.response.status === 401) {
                            window.localStorage.clear();
                            delete axios.defaults.headers.common["Authorization"];
                            router.push('/auth/logout');
                        }
                        reject(error)
                    })
            })
        } else {
            let listsKeys = Object.keys(state.lists)
            for (let i = 0; i < listsKeys.length; i++) {
                await idb.saveIdb({ data: state.lists[listsKeys[i]], list: listsKeys[i] })
                let listsDatadb = await idb.getIdb(listsKeys[i])
                if (listsDatadb !== undefined) {
                    listsDatadb.forEach(c => {
                        if (state.lists[listsKeys[i]].find(list => list.id === c.id) === undefined) {
                            state.lists[listsKeys[i]].push(c)
                        }
                    });
                }

            }
        }
    },
    async getDataMultiples({ commit, state }, config) {
        if (state.produccion === false) {
            return new Promise((resolve, reject) => {
                axios
                    .get(config.route, { params: { data: config.data } })
                    .then(async response => {
                        if (response.data.data) {

                            let data = asign_data().dataMultiple
                            let namePathDataMultiple = Object.keys(data)
                            for (let i = 0; i < namePathDataMultiple.length; i++) {
                                let listsKeys = Object.keys(response.data.data)
                                for (let j = 0; j < listsKeys.length; j++) {
                                    if (response.data.data[listsKeys[j]].length > 0) {
                                        await idb.saveIdb({ data: response.data.data[listsKeys[j]], list: listsKeys[j] })
                                    }
                                    data[namePathDataMultiple[i]][listsKeys[j]] = await idb.buscarIdb({ tabla: listsKeys[j], campo: 'view', value: 0 })
                                    state.predeterminados[namePathDataMultiple[i]][listsKeys[j]] = deepCopy(data[namePathDataMultiple[i]][listsKeys[j]])

                                }
                            }
                            state.dataMultiple = data
                        }

                        resolve(true)
                    }, error => {
                        let statusError = {...error }
                        if (statusError.response.status === 401) {
                            window.localStorage.clear();
                            delete axios.defaults.headers.common["Authorization"];
                            router.push('/auth/logout');
                        }
                        reject(error)
                    })
            })
        } else {
            let listsKeys = Object.keys(state.lists)
            for (let i = 0; i < listsKeys.length; i++) {
                await idb.saveIdb({ data: state.lists[listsKeys[i]], list: listsKeys[i] })
                let listsDatadb = await idb.getIdb(listsKeys[i])
                if (listsDatadb !== undefined) {
                    listsDatadb.forEach(c => {
                        if (state.lists[listsKeys[i]].find(list => list.id === c.id) === undefined) {
                            state.lists[listsKeys[i]].push(c)
                        }
                    });
                }

            }
        }
    },
    async getData({ commit, state }, config) {
        if (state.produccion === false) {
            return new Promise((resolve, reject) => {
                axios
                    .get(config.route, { params: { data: config.data } })
                    .then(async response => {
                        resolve(response.data.data)
                    }, error => {
                        let statusError = {...error }
                        if (statusError.response.status === 401) {
                            window.localStorage.clear();
                            delete axios.defaults.headers.common["Authorization"];
                            router.push('/auth/logout');
                        }
                        reject(error)
                    })
            })
        } else {
            let listsKeys = Object.keys(state.lists)
            for (let i = 0; i < listsKeys.length; i++) {
                await idb.saveIdb({ data: state.lists[listsKeys[i]], list: listsKeys[i] })
                let listsDatadb = await idb.getIdb(listsKeys[i])
                if (listsDatadb !== undefined) {
                    listsDatadb.forEach(c => {
                        if (state.lists[listsKeys[i]].find(list => list.id === c.id) === undefined) {
                            state.lists[listsKeys[i]].push(c)
                        }
                    });
                }

            }
        }
    },
    async getDataConfig({ commit, state }, config) {
        if (state.produccion === false) {
            return new Promise((resolve, reject) => {
                axios
                    .get(config.route, { params: { data: config.data } })
                    .then(async response => {
                        if (response.data.data) {
                            let listsKeys = Object.keys(response.data.data)
                            for (let i = 0; i < listsKeys.length; i++) {
                                if (listsKeys[i] != 'conteo' && listsKeys[i] != 'users') {
                                    state.predeterminados.configuracion[listsKeys[i]] = []
                                    if (response.data.data[listsKeys[i]].length > 0) {
                                        await idb.saveIdb({ data: response.data.data[listsKeys[i]], list: listsKeys[i] })

                                    }
                                    let listsDatadb = await idb.getIdb(listsKeys[i])
                                    listsDatadb.forEach(c => {
                                        if (state.predeterminados.configuracion[listsKeys[i]].find(list => list.id === c.id) === undefined) {
                                            state.predeterminados.configuracion[listsKeys[i]].push(c)
                                        } else {
                                            let indexConfig = state.predeterminados.configuracion[listsKeys[i]].findIndex(list => list.id === c.id)
                                            state.predeterminados.configuracion[listsKeys[i]][indexConfig] = c
                                        }
                                    });
                                } else if (listsKeys[i] == 'conteo') {
                                    state.conteoData = response.data.data.conteo
                                } else if (listsKeys[i] == 'users' && response.data.data.users !== null) {
                                    window.localStorage.setItem('user', JSON.stringify(response.data.data.users));
                                    if (config.data.inicial != '2020-01-01') {
                                        location.reload()
                                    }

                                }
                            }
                        }
                        resolve(true)
                    }, error => {
                        let statusError = {...error }
                        if (statusError.response.status === 401) {
                            window.localStorage.clear();
                            delete axios.defaults.headers.common["Authorization"];
                            router.push('/auth/logout');
                        }
                        reject(error)
                    })
            })
        } else {
            let listsKeys = Object.keys(state.lists)
            for (let i = 0; i < listsKeys.length; i++) {
                await idb.saveIdb({ data: state.lists[listsKeys[i]], list: listsKeys[i] })
                let listsDatadb = await idb.getIdb(listsKeys[i])
                if (listsDatadb !== undefined) {
                    listsDatadb.forEach(c => {
                        if (state.lists[listsKeys[i]].find(list => list.id === c.id) === undefined) {
                            state.lists[listsKeys[i]].push(c)
                        }
                    });
                }

            }
        }
    },
    //ACTIONS DATAINDEX      
    resetDataIndex({ commit }, data) {
        return new Promise((resolve) => {
            commit('resetDataIndex', { data: data, callback: resolve })
        })
    },
    updateDataIndex({ commit }, data) {
        return new Promise((resolve) => {
            commit('updateDataIndex', { data: data, callback: resolve })
        })
    },
    //ACTIONS DATAGET      
    resetDataGet({ commit }, data) {
        return new Promise((resolve) => {
            commit('resetDataGet', { data: data, callback: resolve })
        })
    },
    spliceDataGet({ commit }, data) {
        return new Promise((resolve) => {
            commit('spliceDataGet', { data: data, callback: resolve })
        })
    },
    updateDataGet({ commit }, data) {
        return new Promise((resolve) => {
            commit('updateDataGet', { data: data, callback: resolve })
        })
    },
    pushDataGet({ commit }, data) {
        return new Promise((resolve) => {
            commit('pushDataGet', { data: data, callback: resolve })
        })
    },
    //ACTIONS DATAFORM      
    assignDataForm({ commit }, data) {
        return new Promise((resolve) => {
            commit('assignDataForm', { data: data, callback: resolve })
        })
    },
    resetDataForm({ commit }, data) {
        return new Promise((resolve) => {
            commit('resetDataForm', { data: data, callback: resolve })
        })
    },
    spliceDataForm({ commit }, data) {
        return new Promise((resolve) => {
            commit('spliceDataForm', { data: data, callback: resolve })
        })
    },
    updateDataForm({ commit }, data) {
        return new Promise((resolve) => {
            commit('updateDataForm', { data: data, callback: resolve })
        })
    },
    changeDataForm({ commit }, data) {
        return new Promise((resolve) => {
            commit('changeDataForm', { data: data, callback: resolve })
        })
    },
    pushDataForm({ commit }, data) {
        return new Promise((resolve) => {
            commit('pushDataForm', { data: data, callback: resolve })
        })
    },
    // ACTIONS DATAPOST
    resetDataPost({ commit }, data) {
        return new Promise((resolve) => {
            commit('resetDataPost', { data: data, callback: resolve })
        })
    },
    spliceDataPost({ commit }, data) {
        return new Promise((resolve) => {
            commit('spliceDataPost', { data: data, callback: resolve })
        })
    },
    pushDataPost({ commit }, data) {
        return new Promise((resolve) => {
            commit('pushDataPost', { data: data, callback: resolve })
        })
    },
    updateDataPost({ commit }, data) {
        return new Promise((resolve) => {
            commit('updateDataPost', { data: data, callback: resolve })
        })
    },
    changeDataPost({ commit }, data) {
        return new Promise((resolve) => {
            commit('changeDataPost', { data: data, callback: resolve })
        })
    },
    //ACTIONS OTHERS CRUD
    changeRender({ commit }, data) {
        return new Promise((resolve) => {
            commit('changeRender', { data: '', callback: resolve })
        })
    },
    spliceCrud({ commit }, data) {
        return new Promise((resolve) => {
            commit('spliceCrud', { data: data, callback: resolve })
        })
    },
    pushCrud({ commit }, data) {
        return new Promise((resolve) => {
            commit('pushCrud', { data: data, callback: resolve })
        })
    },
    resetCrud({ commit }, data) {
        return new Promise((resolve) => {
            commit('resetCrud', { data: data, callback: resolve })
        })
    },
    updateCrud({ commit }, data) {
        return new Promise((resolve) => {
            commit('updateCrud', { data: data, callback: resolve })
        })
    },
    changeCrud({ commit }, data) {
        return new Promise((resolve) => {
            commit('changeCrud', { data: data, callback: resolve })
        })
    }
};
// Mutations
export const mutations = {
    formToPost(state, { data, callback }) {
        try {
            for (let i = 0; i < data.length; i++) {
                state.dataPost[state.namePath].data[state.dataIndex[state.namePath]][data[i]] = deepCopy(state.dataForm[state.namePath][data[i]])
            }
            callback(true)
        } catch {

        }
    },
    postToForm(state, { data, callback }) {
        try {
            let tablasDataPost = Object.keys(state.dataPost[state.namePath].data[state.dataIndex[state.namePath]])
            for (let i = 0; i < tablasDataPost.length; i++) {
                state.dataForm[state.namePath][tablasDataPost[i]] = deepCopy(state.dataPost[state.namePath].data[state.dataIndex[state.namePath]][tablasDataPost[i]])
            }
            callback(true)
        } catch {

        }
    },
    spliceDataForm(state, { data, callback }) {
        try {
            var listState = data.state.split('/')
            var index = data.index

            if (data.search !== '' && data.search !== undefined) {
                var variable = ''

                switch (listState.length) {
                    case 1:
                        variable = deepCopy(state.dataForm[state.namePath][listState[0]])
                        break
                    case 2:
                        variable = deepCopy(state.dataForm[state.namePath][listState[0]][listState[1]])
                        break
                    case 3:
                        variable = deepCopy(state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]])
                        break
                    case 4:
                        variable = deepCopy(state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]])
                        break
                    case 5:
                        variable = deepCopy(state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]])
                        break
                    case 6:
                        variable = deepCopy(state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]])
                        break
                    case 7:
                        variable = deepCopy(state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]])
                        break
                    case 8:
                        variable = deepCopy(state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]])
                        break
                    case 9:
                        variable = deepCopy(state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]][listState[8]])
                        break
                }

                for (var i = 0; i < variable.length; i++) {
                    if (variable[i][data.campo] == data.search) {
                        index = i
                        i = variable.length
                    }
                }
            }

            switch (listState.length) {
                case 1:
                    state.dataForm[state.namePath][listState[0]].splice(index, 1)
                    callback(true)
                    break
                case 2:
                    state.dataForm[state.namePath][listState[0]][listState[1]].splice(index, 1)
                    callback(true)
                    break
                case 3:
                    state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]].splice(index, 1)
                    callback(true)
                    break
                case 4:
                    state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]].splice(index, 1)
                    callback(true)
                    break
                case 5:
                    state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]].splice(index, 1)
                    callback(true)
                    break
                case 6:
                    state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]].splice(index, 1)
                    callback(true)
                    break
                case 7:
                    state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]].splice(index, 1)
                    callback(true)
                    break
                case 8:
                    state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]].splice(index, 1)
                    callback(true)
                    break
                case 9:
                    state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]][listState[8]].splice(index, 1)
                    callback(true)
                    break
            }
        } catch (error) {
            console.log('error in globalStore/mutation/splice,', error)
        }
    },
    changeDataForm(state, { data, callback }) {
        try {
            var listState = data.state.split('/')
            if (data.boolean === '') {
                switch (listState.length) {
                    case 1:
                        state[listState[0]] = !state[listState[0]]
                        callback(true)
                        break
                    case 2:
                        state.dataForm[state.namePath][listState[0]][listState[1]] = !state.dataForm[state.namePath][listState[0]][listState[1]]
                        callback(true)
                        break
                    case 3:
                        state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]] = !state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]]
                        callback(true)
                        break
                    case 4:
                        state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]] = !state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]]
                        callback(true)
                        break
                    case 5:
                        state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]] = !state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]]
                        callback(true)
                        break
                    case 6:
                        state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]] = !state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]]
                        callback(true)
                        break
                    case 7:
                        state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]] = !state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]]
                        callback(true)
                        break
                    case 8:
                        state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]] = !state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]]
                        callback(true)
                        break
                    case 9:
                        state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]][listState[8]] = !state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]][listState[8]]
                        callback(true)
                        break
                }
            } else {
                switch (listState.length) {
                    case 1:
                        state[listState[0]] = data.boolean
                        callback(true)
                        break
                    case 2:
                        state.dataForm[state.namePath][listState[0]][listState[1]] = data.boolean
                        callback(true)
                        break
                    case 3:
                        state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]] = data.boolean
                        callback(true)
                        break
                    case 4:
                        state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]] = data.boolean
                        callback(true)
                        break
                    case 5:
                        state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]] = data.boolean
                        callback(true)
                        break
                    case 6:
                        state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]] = data.boolean
                        callback(true)
                        break
                    case 7:
                        state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]] = data.boolean
                        callback(true)
                        break
                    case 8:
                        state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]] = data.boolean
                        callback(true)
                        break
                    case 9:
                        state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]][listState[8]] = data.boolean
                        callback(true)
                        break
                }
            }
        } catch (error) {
            console.log('error in globalStore/mutation/change,', error)
        }
    },
    updateDataForm(state, { data, callback }) {
        try {
            if (data.state === undefined) {
                state.dataForm[state.namePath] = deepCopy(data.data)
            } else {
                var listState = data.state.split('/')
                switch (listState.length) {
                    case 1:
                        state.dataForm[state.namePath][listState[0]] = deepCopy(data.data)
                        break
                    case 2:
                        state.dataForm[state.namePath][listState[0]][listState[1]] = deepCopy(data.data)
                        break
                    case 3:
                        state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]] = deepCopy(data.data)
                        break
                    case 4:
                        state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]] = deepCopy(data.data)
                        break
                    case 5:
                        state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]] = deepCopy(data.data)
                        break
                    case 6:
                        state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]] = deepCopy(data.data)
                        break
                    case 7:
                        state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]] = deepCopy(data.data)
                        break
                    case 8:
                        state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]] = deepCopy(data.data)
                        break
                    case 9:
                        state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]][listState[8]] = deepCopy(data.data)
                        break
                }
            }
            callback(true)
        } catch (error) {
            console.log('error  in crudStore/mutation/update (line 1009),', error)
            callback(false)
        }
    },
    assignDataForm(state, { data, callback }) {
        try {
            Object.assign(state.dataForm[state.namePath][data.state], data.data);
            callback(true)
        } catch (e) {
            console.log(e)
        }
    },
    resetDataForm(state, { data, callback }) {
        try {
            let resolved
            if (data === undefined) {
                state.dataForm[state.namePath] = reset().dataForm[state.namePath]
                resolved = reset().dataForm[state.namePath]
            } else {
                var listState = data.state.split('/')
                switch (listState.length) {
                    case 1:
                        state.dataForm[state.namePath][listState[0]] = reset().dataForm[state.namePath][listState[0]]
                        resolved = reset().dataForm[state.namePath][listState[0]]
                        break
                    case 2:
                        state.dataForm[state.namePath][listState[0]][listState[1]] = reset().dataForm[state.namePath][listState[0]][listState[1]]
                        resolved = reset().dataForm[state.namePath][listState[0]][listState[1]]
                        break
                    case 3:
                        state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]] = reset().dataForm[state.namePath][listState[0]][listState[1]][listState[2]]
                        resolved = reset().dataForm[state.namePath][listState[0]][listState[1]][listState[2]]
                        break
                    case 4:
                        state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]] = reset().dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]]
                        resolved = reset().dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]]
                        break
                    case 5:
                        state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]] = reset().dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]]
                        resolved = reset().dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]]
                        break
                    case 6:
                        state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]] = reset().dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]]
                        resolved = reset().dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]]
                        break
                    case 7:
                        state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]] = reset().dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]]
                        resolved = reset().dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]]
                        break
                    case 8:
                        state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]] = reset().dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]]
                        resolved = reset().dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]]
                        break
                    case 9:
                        state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]][listState[8]] = reset().dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]][listState[8]]
                        resolved = reset().dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]][listState[8]]
                        break
                }
            }
            if (resolved === undefined) {
                throw ('state ' + data + ' undefined')
            }
            callback(true)

        } catch (error) {
            console.log('error in globalStore/mutation/reset,', error)
            callback(false)
        }
    },
    pushDataForm(state, { data, callback }) {
        try {
            var listState = data.state.split('/')
            switch (listState.length) {
                case 1:
                    state.dataForm[state.namePath][listState[0]].push(deepCopy(data.data))
                    callback(true)
                    break
                case 2:
                    state.dataForm[state.namePath][listState[0]][listState[1]].push(deepCopy(data.data))
                    callback(true)
                    break
                case 3:
                    state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]].push(deepCopy(data.data))
                    callback(true)
                    break
                case 4:
                    state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]].push(deepCopy(data.data))
                    callback(true)
                    break
                case 5:
                    state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]] = push(deepCopy(data.data))
                    callback(true)
                    break
                case 6:
                    state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]] = push(deepCopy(data.data))
                    callback(true)
                    break
                case 7:
                    state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]] = push(deepCopy(data.data))
                    callback(true)
                    break
                case 8:
                    state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]] = push(deepCopy(data.data))
                    callback(true)
                    break
                case 9:
                    state.dataForm[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]][listState[8]] = push(deepCopy(data.data))
                    callback(true)
                    break
            }
        } catch (error) {
            console.log('error in globalStore/mutation/push,', error, 'data', data)
        }
    },
    spliceDataPost(state, { data, callback }) {
        try {
            var index = data
            if (index !== undefined && typeof index === 'number') {
                state.dataPost[state.namePath].data.splice(index, 1)
                callback(true)
            }
        } catch (error) {
            console.log('error in globalStore/mutation/splice,', error)
            callback(false)
        }
    },
    changeDataPost(state, { data, callback }) {
        try {
            var listState = data.state.split('/')
            if (data.boolean === '') {
                switch (listState.length) {
                    case 1:
                        state[listState[0]] = !state[listState[0]]
                        callback(true)
                        break
                    case 2:
                        state.dataPost[state.namePath][listState[0]][listState[1]] = !state.dataPost[state.namePath][listState[0]][listState[1]]
                        callback(true)
                        break
                    case 3:
                        state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]] = !state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]]
                        callback(true)
                        break
                    case 4:
                        state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]] = !state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]]
                        callback(true)
                        break
                    case 5:
                        state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]] = !state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]]
                        callback(true)
                        break
                    case 6:
                        state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]] = !state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]]
                        callback(true)
                        break
                    case 7:
                        state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]] = !state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]]
                        callback(true)
                        break
                    case 8:
                        state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]] = !state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]]
                        callback(true)
                        break
                    case 9:
                        state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]][listState[8]] = !state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]][listState[8]]
                        callback(true)
                        break
                }
            } else {
                switch (listState.length) {
                    case 1:
                        state[listState[0]] = data.boolean
                        callback(true)
                        break
                    case 2:
                        state.dataPost[state.namePath][listState[0]][listState[1]] = data.boolean
                        callback(true)
                        break
                    case 3:
                        state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]] = data.boolean
                        callback(true)
                        break
                    case 4:
                        state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]] = data.boolean
                        callback(true)
                        break
                    case 5:
                        state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]] = data.boolean
                        callback(true)
                        break
                    case 6:
                        state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]] = data.boolean
                        callback(true)
                        break
                    case 7:
                        state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]] = data.boolean
                        callback(true)
                        break
                    case 8:
                        state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]] = data.boolean
                        callback(true)
                        break
                    case 9:
                        state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]][listState[8]] = data.boolean
                        callback(true)
                        break
                }
            }
        } catch (error) {
            console.log('error in globalStore/mutation/change,', error)
        }
    },
    updateDataPost(state, { data, callback }) {
        try {

            if (data.state === undefined) {
                state.dataPost[state.namePath] = deepCopy(data.data)
                callback(true)
            } else {
                var listState = data.state.split('/')
                switch (listState.length) {
                    case 1:
                        state.dataPost[state.namePath][listState[0]] = deepCopy(data.data)
                        state.renderForce++
                            callback(true)
                        break
                    case 2:
                        state.dataPost[state.namePath][listState[0]][listState[1]] = deepCopy(data.data)
                        state.renderForce++
                            callback(true)
                        break
                    case 3:
                        state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]] = deepCopy(data.data)
                        state.renderForce++
                            callback(true)
                        break
                    case 4:
                        state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]] = deepCopy(data.data)
                        state.renderForce++
                            callback(true)
                        break
                    case 5:
                        state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]] = deepCopy(data.data)
                        state.renderForce++
                            callback(true)
                        break
                    case 6:
                        state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]] = deepCopy(data.data)
                        state.renderForce++
                            callback(true)
                        break
                    case 7:
                        state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]] = deepCopy(data.data)
                        state.renderForce++
                            callback(true)
                        break
                    case 8:
                        state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]] = deepCopy(data.data)
                        state.renderForce++
                            callback(true)
                        break
                    case 9:
                        state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]][listState[8]] = deepCopy(data.data)
                        state.renderForce++
                            callback(true)
                        break
                }
            }
        } catch (error) {
            console.log('error in globalStore/mutation/update,', error)
        }
    },
    resetDataPost(state, { data, callback }) {
        try {
            if (data === undefined) {
                state.dataPost[state.namePath] = reset().dataPost[state.namePath]
                callback(true)
            } else {
                var listState = data.state.split('/')
                switch (listState.length) {
                    case 1:
                        state.dataPost[state.namePath][listState[0]] = reset().dataPost[state.namePath][listState[0]]
                        callback(true)
                        break
                    case 2:
                        state.dataPost[state.namePath][listState[0]][listState[1]] = reset().dataPost[state.namePath][listState[0]][listState[1]]
                        callback(true)
                        break
                    case 3:
                        state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]] = reset().dataPost[state.namePath][listState[0]][listState[1]][listState[2]]
                        callback(true)
                        break
                    case 4:
                        state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]] = reset().dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]]
                        callback(true)
                        break
                    case 5:
                        state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]] = reset().dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]]
                        callback(true)
                        break
                    case 6:
                        state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]] = reset().dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]]
                        callback(true)
                        break
                    case 7:
                        state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]] = reset().dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]]
                        callback(true)
                        break
                    case 8:
                        state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]] = reset().dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]]
                        callback(true)
                        break
                    case 9:
                        state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]][listState[8]] = reset().dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]][listState[8]]
                        callback(true)
                        break
                }
            }

        } catch (error) {
            console.log('error in globalStore/mutation/reset,', error)
        }
    },
    pushDataPost(state, { data, callback }) {
        try {
            var listState = data.state.split('/')
            switch (listState.length) {
                case 1:
                    state.dataPost[state.namePath][listState[0]].push(deepCopy(data.data))
                    state.renderForce++
                        callback(true)
                    break
                case 2:
                    state.dataPost[state.namePath][listState[0]][listState[1]].push(deepCopy(data.data))
                    state.renderForce++
                        callback(true)
                    break
                case 3:
                    state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]].push(deepCopy(data.data))
                    state.renderForce++
                        callback(true)
                    break
                case 4:
                    state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]].push(deepCopy(data.data))
                    state.renderForce++
                        callback(true)
                    break
                case 5:
                    state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]] = push(deepCopy(data.data))
                    state.renderForce++
                        callback(true)
                    break
                case 6:
                    state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]] = push(data.boolean)
                    state.renderForce++
                        callback(true)
                    break
                case 7:
                    state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]] = push(data.boolean)
                    state.renderForce++
                        callback(true)
                    break
                case 8:
                    state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]] = push(data.boolean)
                    state.renderForce++
                        callback(true)
                    break
                case 9:
                    state.dataPost[state.namePath][listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]][listState[8]] = push(data.boolean)
                    state.renderForce++
                        callback(true)
                    break
            }
        } catch (error) {
            console.log('error in globalStore/mutation/push,', error)
        }
    },
    resetDataIndex(state, { data, callback }) {
        try {
            state.dataIndex[state.namePath] = reset().dataIndex[state.namePath]
            callback(true)
        } catch (error) {
            console.log('error in globalStore/mutation/reset,', error)
        }
    },
    updateDataIndex(state, { data, callback }) {
        try {
            if (data.data !== undefined) {
                state.dataIndex[state.namePath] = data.data
                callback(true)
            } else {
                throw ('data is undefined')
            }

        } catch (error) {
            console.log('error in globalStore/mutation/updateDataIndex,', error)
            callback(false)

        }
    },
    resetDataGet(state, { data, callback }) {
        try {
            state.dataGet[state.namePath] = reset().dataGet[state.namePath]
            callback(true)
        } catch (error) {
            console.log('error in globalStore/mutation/resetDataGet,', error)
        }
    },
    spliceDataGet(state, { data, callback }) {
        try {
            var index = data
            if (index !== undefined && typeof index === 'number') {
                state.dataGet[state.namePath].data.splice(index, 1)
                callback(true)
            }
        } catch (error) {
            console.log('error in globalStore/mutation/spliceDataGet,', error)
        }
    },
    updateDataGet(state, { data, callback }) {
        try {
            if (data.index !== undefined) {
                if (data.state !== undefined) {
                    var listState = data.state.split('/')
                    switch (listState.length) {
                        case 1:
                            state.dataGet[state.namePath].data[data.index][listState[0]] = deepCopy(data.data)
                            break;
                        case 2:
                            state.dataGet[state.namePath].data[data.index][listState[0]][listState[1]] = deepCopy(data.data)
                            break;
                        case 3:
                            state.dataGet[state.namePath].data[data.index][listState[0]][listState[1]][listState[2]] = deepCopy(data.data)
                            break;
                    }
                } else {
                    Vue.set(state.dataGet[state.namePath].data, data.index, deepCopy(data.data))
                }

            } else {
                state.dataGet[state.namePath].data = deepCopy(data)
            }
            state.renderForce++
                callback(true)
        } catch (error) {
            console.log('error in globalStore/mutation/updateDataGet,', error)
        }
    },
    pushDataGet(state, { data, callback }) {
        try {
            state.dataGet[state.namePath].data.push(data.data)
            state.renderForce++
                callback(true)
        } catch (error) {
            console.log('error in globalStore/mutation/pushDataGet,', error)
        }
    },
    pushCrud(state, { data, callback }) {
        try {
            var listState = data.state.split('/')
            switch (listState.length) {
                case 1:
                    state[listState[0]].push(deepCopy(data.data))
                    callback(true)
                    break
                case 2:
                    state[listState[0]][listState[1]].push(deepCopy(data.data))
                    callback(true)
                    break
                case 3:
                    state[listState[0]][listState[1]][listState[2]].push(deepCopy(data.data))
                    callback(true)
                    break
                case 4:
                    state[listState[0]][listState[1]][listState[2]][listState[3]].push(deepCopy(data.data))
                    callback(true)
                    break
                case 5:
                    state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]] = push(deepCopy(data.data))
                    callback(true)
                    break
                case 6:
                    state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]] = push(deepCopy(data.data))
                    callback(true)
                    break
                case 7:
                    state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]] = push(deepCopy(data.data))
                    callback(true)
                    break
                case 8:
                    state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]] = push(deepCopy(data.data))
                    callback(true)
                    break
                case 9:
                    state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]][listState[8]] = push(deepCopy(data.data))
                    callback(true)
                    break
            }
        } catch (error) {
            console.log('error in globalStore/mutation/push,', error)
        }
    },
    updateCrud(state, { data, callback }) {
        try {
            var listState = data.state.split('/')
            switch (listState.length) {
                case 1:
                    state[listState[0]] = deepCopy(data.data)
                    state.renderForce++
                        callback(true)
                    break
                case 2:
                    state[listState[0]][listState[1]] = deepCopy(data.data)
                    state.renderForce++
                        callback(true)
                    break
                case 3:
                    state[listState[0]][listState[1]][listState[2]] = deepCopy(data.data)
                    state.renderForce++
                        callback(true)
                    break
                case 4:
                    state[listState[0]][listState[1]][listState[2]][listState[3]] = deepCopy(data.data)
                    state.renderForce++
                        callback(true)
                    break
                case 5:
                    state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]] = deepCopy(data.data)
                    state.renderForce++
                        callback(true)
                    break
                case 6:
                    state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]] = deepCopy(data.data)
                    state.renderForce++
                        callback(true)
                    break
                case 7:
                    state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]] = deepCopy(data.data)
                    state.renderForce++
                        callback(true)
                    break
                case 8:
                    state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]] = deepCopy(data.data)
                    state.renderForce++
                        callback(true)
                    break
                case 9:
                    state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]][listState[8]] = deepCopy(data.data)
                    state.renderForce++
                        callback(true)
                    break
            }
        } catch (error) {
            console.log('error in globalStore/mutation/updateCrud,', error)
        }
    },
    changeCrud(state, { data, callback }) {
        try {
            var listState = data.state.split('/')
            if (data.boolean === '') {
                switch (listState.length) {
                    case 1:
                        state[listState[0]] = !state[listState[0]]
                        state.renderForce++
                            callback(true)
                        break
                    case 2:
                        state[listState[0]][listState[1]] = !state[listState[0]][listState[1]]
                        state.renderForce++
                            callback(true)
                        break
                    case 3:
                        state[listState[0]][listState[1]][listState[2]] = !state[listState[0]][listState[1]][listState[2]]
                        state.renderForce++
                            callback(true)
                        break
                    case 4:
                        state[listState[0]][listState[1]][listState[2]][listState[3]] = !state[listState[0]][listState[1]][listState[2]][listState[3]]
                        state.renderForce++
                            callback(true)
                        break
                    case 5:
                        state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]] = !state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]]
                        state.renderForce++
                            callback(true)
                        break
                    case 6:
                        state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]] = !state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]]
                        state.renderForce++
                            state.renderForce++
                            callback(true)
                        break
                    case 7:
                        state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]] = !state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]]
                        state.renderForce++
                            callback(true)
                        break
                    case 8:
                        state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]] = !state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]]
                        state.renderForce++
                            callback(true)
                        break
                    case 9:
                        state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]][listState[8]] = !state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]][listState[8]]
                        state.renderForce++
                            callback(true)
                        break
                }
            } else {

                switch (listState.length) {
                    case 1:
                        state[listState[0]] = data.boolean
                        callback(true)
                        break
                    case 2:
                        state[listState[0]][listState[1]] = data.boolean
                        callback(true)
                        break
                    case 3:
                        state[listState[0]][listState[1]][listState[2]] = data.boolean
                        callback(true)
                        break
                    case 4:
                        state[listState[0]][listState[1]][listState[2]][listState[3]] = data.boolean
                        callback(true)
                        break
                    case 5:
                        state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]] = data.boolean
                        callback(true)
                        break
                    case 6:
                        state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]] = data.boolean
                        callback(true)
                        break
                    case 7:
                        state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]] = data.boolean
                        callback(true)
                        break
                    case 8:
                        state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]] = data.boolean
                        callback(true)
                        break
                    case 9:
                        state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]][listState[8]] = data.boolean
                        callback(true)
                        break
                }
            }
        } catch (error) {
            console.log('error in globalStore/mutation/change,', error)
        }
    },
    resetCrud(state, { data, callback }) {
        try {
            var listState = data.state.split('/')
            switch (listState.length) {
                case 1:
                    state[listState[0]] = reset()[listState[0]]
                    callback(true)
                    break
                case 2:
                    state[listState[0]][listState[1]] = reset()[listState[0]][listState[1]]
                    callback(true)
                    break
                case 3:
                    state[listState[0]][listState[1]][listState[2]] = reset()[listState[0]][listState[1]][listState[2]]
                    callback(true)
                    break
                case 4:
                    state[listState[0]][listState[1]][listState[2]][listState[3]] = reset()[listState[0]][listState[1]][listState[2]][listState[3]]
                    callback(true)
                    break
                case 5:
                    state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]] = reset()[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]]
                    callback(true)
                    break
                case 6:
                    state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]] = reset()[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]]
                    callback(true)
                    break
                case 7:
                    state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]] = reset()[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]]
                    callback(true)
                    break
                case 8:
                    state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]] = reset()[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]]
                    callback(true)
                    break
                case 9:
                    state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]][listState[8]] = reset()[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]][listState[8]]
                    callback(true)
                    break
            }


        } catch (error) {
            console.log('error in globalStore/mutation/reset,', error)
        }
    },
    updateDataMultiple(state, { data, callback }) {
        try {
            var control = false
            for (var i = 0; i < data.data.length; i++) {

                control = state.dataMultiple[state.namePath][data.state].findIndex(items => items.name === data.data[i].name)
                if (control >= 0) {
                    Vue.set(state.dataMultiple[state.namePath][data.state], control, deepCopy(data.data[i]))
                }
            }
            callback(true)
        } catch {

        }
    },
}